// Unpublished Work © 2026 Deere & Company.

function stringifyValue(value) {
    if (value === null || value === undefined) {
        return '';
    }

    const str = typeof value === 'object' ? JSON.stringify(value) : String(value);

    if (/[",\r\n]/.test(str)) {
        return `"${str.replaceAll(/"/g, '""')}"`;
    }

    return str;
}

/**
 * Generate CSV's content from an object, most likely the jobs data from Labor
 *
 * @param {Array<object>} data - Array of objects
 * @param {Array<object>} acceptedHeaders - Array of header objects with `key` and `label` properties
 * @returns {string} - CSV content as a string
 */
export function createCSV(data, acceptedHeaders = []) {
    if (data.length === 0) {
        return '';
    }

    const headers = acceptedHeaders.length > 0 ? acceptedHeaders : Object.keys(data[0]).map((key) => ({
        key,
        label: key
    }));
    const rows = data.map((obj) =>
        headers.map((header) => stringifyValue(obj[header.key])).join(',')
    );

    return [headers.map((header) => header.label).join(','), ...rows].join('\n');
}

/**
 * Takes the string and create a Blob to trigger the download of a CSV file with the given filename
 *
 * @param {string} csvString - CSV content as a string
 * @param {string} filename - Name of the file to be downloaded
 * @returns {void}
 */
export function downloadCSV(csvString, filename = 'data.csv') {
    const blob = new Blob([csvString], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    link.click();
}
